import type { ForcedSubject } from '@casl/ability'
import useAbilityStore from './useAbilityStore'

export type RoleAbilityProp = {
  i: string
  this: string | ForcedSubject<string>
  field?: string
}[]

const useAbilityAccess = (abilities: RoleAbilityProp): boolean => {
  const abilityInstance = useAbilityStore()

  if (!abilities || abilities.length === 0) {
    return true
  }

  return abilities.every(({ i: action, this: subject, field }) =>
    abilityInstance.can(action, subject, field)
  )
}

export default useAbilityAccess
